// @flow
import * as React from "react";
import styled from "styled-components";

type BetProps = {
  fill?: string,
  className?: string,
  d: string
};

const BetIcon = (props: BetProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="7"
    viewBox="0 0 9 7"
    fill={props.fill}
    className={props.className}
  >
    <path d={props.d} />
  </svg>
);

const Up = styled(BetIcon)`
  fill: ${({ theme }) => theme.upper};
`;

const Down = styled(BetIcon)`
  fill: ${({ theme }) => theme.lower};
`;

export const UpIcon = () => <Up d="M4.5,0.494L0.779,6.921H8.226L4.5,0.494" />;

export const DownIcon = () => (
  <Down d="M4.5,7.384L0.779,0.958H8.226L4.5,7.384" />
);



// WEBPACK FOOTER //
// ./src/components/Icons/Bet.js